import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "inputSection"];
  static values = { deleteUrl: String };

  toggle() {
    if (this.checkboxTarget.checked) {
      this.inputSectionTarget.classList.remove("hidden");
    } else {
      this.inputSectionTarget.classList.add("hidden");
      if (this.deleteUrlValue && this.deleteUrlValue !== "") {
        this.deleteDiscount();
      }
    }
  }

  deleteDiscount() {
    if (!confirm("Are you sure you want to remove this discount?")) {
      this.checkboxTarget.checked = true;
      this.inputSectionTarget.classList.remove("hidden");
      return;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.deleteUrlValue;

    const csrfToken = document.querySelector("[name='csrf-token']").content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "delete";
    form.appendChild(methodInput);

    document.body.appendChild(form);
    form.submit();
  }
}
